import css from "styled-jsx/css";

export { colorsStyles } from "./styles/colors-styles.scss";
export { fontsStyles } from "./styles/fonts-styles.scss";

export const componentStyles = css.global`
  button.ladda-button {
    padding: 16px 32px;
    cursor: pointer;
    font-size: 18px;
    border-radius: 40px;
    border: none;
    font-weight: 400;
    text-align: center;
    cursor: pointer;
    user-select: none;
    line-height: 17px;

    &[data-style="zoom-in"] {
      &:not(:hover) {
        transition: 0.1s ease background-color;
      }
    }

    &.disable-animation {
      &.ladda-button[data-style="zoom-out"] .ladda-label {
        transition: none !important;
        z-index: 0;
      }

      &.ladda-button .ladda-label {
        transition: none !important;
        z-index: 0;
      }
    }

    &.has-arrow {
      padding: 16px 32px 16px 31px;
      &.sm {
        padding-left: 29px;
      }
    }

    &.invert {
      border-width: 1px;
      border-style: solid;
    }

    &:disabled {
      cursor: auto;
    }

    &:hover {
      outline: none;
    }

    img {
      vertical-align: middle;
    }
  }
`;
